(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1399px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel-custom"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(
        this.querySelectorAll('.hero-carousel__slide')
      );

      if (!this.slides.length) return;

      this.currentIndex = 0;
      this.timer = null;

      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = parseInt(this.dataset.interval, 10) || 6000;

      this.setupSlides();

      if (
        this.autoplay &&
        this.slides.length > 1 &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        this.startAutoplay();

        this.handleMouseEnter = this.stopAutoplay.bind(this);
        this.handleMouseLeave = this.startAutoplay.bind(this);
        this.handleVisibility = this.onVisibilityChange.bind(this);

        this.addEventListener('mouseenter', this.handleMouseEnter);
        this.addEventListener('mouseleave', this.handleMouseLeave);
        document.addEventListener(
          'visibilitychange',
          this.handleVisibility
        );
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();

      this.removeEventListener(
        'mouseenter',
        this.handleMouseEnter
      );

      this.removeEventListener(
        'mouseleave',
        this.handleMouseLeave
      );

      document.removeEventListener(
        'visibilitychange',
        this.handleVisibility
      );
    }

    setupSlides() {
      this.slides.forEach((slide, index) => {
        if (index === 0) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });
    }

    startAutoplay() {
      this.stopAutoplay();

      this.timer = setInterval(() => {
        this.nextSlide();
      }, this.interval);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    nextSlide() {
      const currentSlide = this.slides[this.currentIndex];

      this.currentIndex =
        (this.currentIndex + 1) % this.slides.length;

      const nextSlide = this.slides[this.currentIndex];

      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');
    }

    onVisibilityChange() {
      if (document.hidden) {
        this.stopAutoplay();
      } else if (this.autoplay) {
        this.startAutoplay();
      }
    }
  }

  if (!customElements.get('hero-carousel')) {
    customElements.define('hero-carousel', HeroCarousel);
  }

  document.addEventListener('shopify:section:load', function(event) {
    const carousel = event.target.querySelector('hero-carousel');

    if (carousel && typeof carousel.connectedCallback === 'function') {
      carousel.connectedCallback();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = this.querySelectorAll('.hero-carousel__slide');
      if (this.slides.length <= 1) return;
      if (this.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.currentIndex = 0;
      this.timer = null;

      this.onEnter = () => this.stop();
      this.onLeave = () => this.start();
      this.onVisibility = () => {
        if (document.hidden) this.stop();
        else this.start();
      };

      this.addEventListener('focusin', this.onEnter);
      this.addEventListener('focusout', this.onLeave);
      document.addEventListener('visibilitychange', this.onVisibility);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.onVisibility) {
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.advance(), this.interval);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    advance() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.slides[this.currentIndex].classList.remove('is-active');
      this.slides[nextIndex].classList.add('is-active');
      this.currentIndex = nextIndex;
    }
  }

  if (!customElements.get('hero-carousel')) {
    customElements.define('hero-carousel', HeroCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
